import React, { useState } from "react";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaBook, FaFlask, FaCalculator, FaBrain, FaArrowDown } from "react-icons/fa"; // Import Course Icons

// Courses Offered
const courses = [
  {
    title: "JEE Main & Advanced",
    description: "Preparation for JEE exams with expert coaching and comprehensive study material.",
    icon: <FaBrain />,
    details: [
      "Course Fees: $1000/month",
      "Class Timings: 4 PM - 6 PM (Mon - Fri)",
      "Duration: 1 Year",
      "Online & Offline Coaching Available"
    ]
  },
  {
    title: "NEET",
    description: "In-depth coaching for NEET exam with subject focus on Biology, Physics, and Chemistry.",
    icon: <FaFlask />,
    details: [
      "Course Fees: $900/month",
      "Class Timings: 5 PM - 7 PM (Mon - Fri)",
      "Duration: 1 Year",
      "Subject-Focused Coaching"
    ]
  },
  {
    title: "CET",
    description: "Thorough coaching for CET exam with emphasis on concepts, problem-solving, and time management.",
    icon: <FaCalculator />,
    details: [
      "Course Fees: $850/month",
      "Class Timings: 6 PM - 8 PM (Mon - Fri)",
      "Duration: 1 Year",
      "Mock Tests & Weekly Assessments"
    ]
  },
  {
    title: "Foundation Course (Class 8-10)",
    description: "Build strong foundations in Maths, Science, and English for school and competitive exams.",
    icon: <FaBook />,
    details: [
      "Course Fees: $500/month",
      "Class Timings: 3 PM - 5 PM (Mon - Fri)",
      "Duration: 6 Months",
      "Special Focus on Conceptual Understanding"
    ]
  },
];

const Courses = () => {
  const [activeCourseIndex, setActiveCourseIndex] = useState(null);

  const toggleCourseDetails = (index) => {
    // Toggle the active course index to show/hide details
    setActiveCourseIndex(activeCourseIndex === index ? null : index);
  };

  return (
    <div className="container-fluid d-flex flex-column align-items-center justify-content-center text-dark bg-white py-5 mt-5">
      {/* Section Title */}
      <motion.h1
        className="text-center fw-bold mb-5"
        style={{ color: "black", borderBottom: "3px solid black", display: "inline-block", paddingBottom: "5px" }}
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        Courses Offered by Prakash Institute
      </motion.h1>

      {/* Courses Section */}
      <div className="row w-100 justify-content-center">
        {courses.map((course, index) => (
          <motion.div
            key={index}
            className="col-12 d-flex justify-content-center mb-4 px-3"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: index * 0.2 }}
          >
            <div
              className="card text-dark p-4 shadow-lg text-center"
              style={{
                backgroundColor: "#FFF",
                borderRadius: "20px",
                borderStyle: "dotted",
                border: "3px solid #000",
                width: "100%", // Card takes full width
                boxShadow: "0 0 15px rgba(0, 0, 0, 0.5)",
                position: "relative", // This allows positioning the arrow on the right
              }}
            >
              <div className="mb-3" style={{ fontSize: "2rem", color: "black" }}>
                {course.icon}
              </div>
              <h3 className="fw-bold mb-2" style={{ color: "black" }}>
                {course.title}
              </h3>
              <p className="fst-italic" style={{ color: "black" }}>
                {course.description}
              </p>

              {/* Arrow to Toggle Details on the Right */}
              <motion.div
                className="d-flex justify-content-end mt-3"
                onClick={() => toggleCourseDetails(index)}
                style={{
                  cursor: "pointer",
                  position: "absolute",
                  top: "50%",
                  right: "20px",
                  transform: "translateY(-50%)",
                }}
              >
                <FaArrowDown size={30} style={{ color: "black" }} />
              </motion.div>

              {/* Show Course Details Only for the Active Course */}
              {activeCourseIndex === index && (
                <div className="mt-3">
                  <ul className="list-unstyled">
                    {course.details.map((detail, detailIndex) => (
                      <li key={detailIndex} style={{ fontSize: "1rem", margin: "5px 0", color: "black" }}>
                        <span style={{ color: "black" }}>• </span>
                        {detail}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Courses;
